import { SET_ORDER_WORKFLOW_PAGE, PaymentMethodTypes, PingOrder, AttemptPayment } from './Types';

import { CreateTitleDeedOrder, UpdateTitleDeedOrder } from '../purchase_deed/Types';

import { OrderReducerState } from './OrderTypes';
import { OrderWorkflow } from './Constants';

const defaultState: OrderReducerState = {
    isPinging: false,
    isCreatingOrder: false,
    isAttemptingPayment: false,
    workflowPage: OrderWorkflow.PRODUCT_SELECTION,
    paymentMethod: null,
    error: null,
    paymentInformationError: null,
    order: null,
    productMessage: null
};

export default function reducer(state: OrderReducerState = defaultState, action: any) {
    switch (action.type) {
        case SET_ORDER_WORKFLOW_PAGE:
            return {
                ...state,
                workflowPage: action.workflowPage
            };
        case PaymentMethodTypes.SET:
            return {
                ...state,
                paymentMethod: action.paymentMethod
            };
        case PaymentMethodTypes.RESET: {
            return {
                ...state,
                paymentMethod: null
            };
        }
        case PingOrder.REQUEST:
            return {
                ...state,
                isPinging: true,
                error: null
            };
        case PingOrder.SUCCESS:
            return {
                ...state,
                isPinging: false,
                order: action.order,
                error: null
            };
        case PingOrder.FAILURE:
            return {
                ...state,
                isPinging: false,
                error: action.error
            };
        case PingOrder.RESET: {
            return {
                ...state,
                isPinging: false,
                order: null
            };
        }
        case AttemptPayment.REQUEST:
            return {
                ...state,
                isAttemptingPayment: true,
                paymentInformationError: null
            };
        case AttemptPayment.SUCCESS:
            return {
                ...state,
                isAttemptingPayment: false,
                order: action.order,
                paymentInformationError: null
            };
        case AttemptPayment.FAILURE:
            return {
                ...state,
                isAttemptingPayment: false,
                paymentInformationError: action.error
            };
        case CreateTitleDeedOrder.REQUEST:
        case UpdateTitleDeedOrder.REQUEST:
            return {
                ...state,
                isCreatingOrder: true,
                error: null
            };
        case CreateTitleDeedOrder.SUCCESS:
        case UpdateTitleDeedOrder.SUCCESS:
            return {
                ...state,
                isCreatingOrder: false,
                order: action.order,
                workflowPage: OrderWorkflow.PAYMENT_INFORMATION
            };
        case CreateTitleDeedOrder.WARNING:
            return {
                ...state,
                isCreatingOrder: false,
                productMessage: action.message
            };
        case CreateTitleDeedOrder.FAILURE:
        case UpdateTitleDeedOrder.FAILURE:
            return {
                ...state,
                isCreatingOrder: false,
                error: action.error,
                workflowPage: OrderWorkflow.PRODUCT_SELECTION
            };
        default:
            return state;
    }
}
